import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import localeText from "../../../../locale";

const CheckoutAddressDialog = ({ visible, onHide, onSubmit, country, checkZipCode }) => {
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [number, setNumber] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");

  const submit = () => {
    const addressData = {
      city,
      state,
      district,
      number,
      postalCode,
      address,
    };

    onSubmit(addressData);
    onHide();
  };

  const footer = (
    <div className="flex justify-content-between">
      <Button
        label="Salvar"
        className="px-4 border-none "
        style={{
          backgroundColor: "#28AB69",
          color: "#FAFBFC",
          paddingTop: "12px",
          paddingBottom: "12px",
        }}
        onClick={() => {
          submit();
        }}
      />
    </div>
  );
  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">{localeText("address")}</span>
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      footer={footer}
      header={headerElement}
      className=""
      style={{ width: "740px" }}
    >
      <div className="grid grid-nogutter gap-3">
        <div className="col-12">
          <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700">
            {localeText("zipCode")}
          </label>
          <InputText
            id="postalCode"
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>
        {/* <div className="col">
          <label htmlFor="search" className="block text-sm font-medium text-gray-700">
            {localeText("searchAddress")}
          </label>
          <Button
            style={{ backgroundColor: "#2e4e5c", color: "#ffffff" }}
            id="search"
            label={localeText("search")}
            className="w-full mt-1 block border-none"
            onClick={() => checkZipCode(postalCode)}
          />
        </div> */}
        <div className="col-12">
          <label htmlFor="country" className="block text-sm font-medium text-gray-700">
            {localeText("country")}
          </label>
          <InputText id="country" value={country} disabled className="w-full mt-1 block" />
        </div>
        <div className="col-6">
          <label htmlFor="state" className="block text-sm font-medium text-gray-700">
            {localeText("state")}
          </label>
          <InputText
            id="state"
            value={state}
            onChange={(e) => setState(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>
        <div className="col">
          <label htmlFor="city" className="block text-sm font-medium text-gray-700">
            {localeText("city")}
          </label>
          <InputText
            id="city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>

        <div className="col-8">
          <label htmlFor="district" className="block text-sm font-medium text-gray-700">
            {localeText("district")}
          </label>
          <InputText
            id="district"
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>
        <div className="col">
          <label htmlFor="number" className="block text-sm font-medium text-gray-700">
            {localeText("number")}
          </label>
          <InputText
            id="number"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>
        <div className="col-12">
          <label htmlFor="address" className="block text-sm font-medium text-gray-700">
            {localeText("publicPlace")}
          </label>
          <InputText
            id="address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="w-full mt-1 block"
          />
        </div>
      </div>
    </Dialog>
  );
};

export default CheckoutAddressDialog;
